import { useParams } from 'react-router-dom';

type ScenarioUrl = {
  scenarioId: string;
};

const useScenarioId = () => {
  const params = useParams<ScenarioUrl>();
  return Number(params.scenarioId);
};

type MaybeScenarioUrl = {
  scenarioId?: string;
};

const useMaybeScenarioId = () => {
  const params = useParams<MaybeScenarioUrl>();
  return params.scenarioId ? Number(params.scenarioId) : undefined;
};

export { useScenarioId, useMaybeScenarioId };
